import * as turf from '@turf/turf';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import { Circle, Polygon } from 'ol/geom';
import { toLonLat, fromLonLat } from 'ol/proj';

import CoordUtils from './CoordUtils';

// 투영된 반지름을 미터로 변환
export const convertProjectedRadiusToMeters = (circle) => {
  const center = circle.getCenter();
  const radius = circle.getRadius();
  const edge = [center[0] + radius, center[1]];

  const centerLatLng = toLonLat(center);
  const edgeLatLng = toLonLat(edge);

  return turf.distance(centerLatLng, edgeLatLng, { units: 'meters' });
};

// 미터를 투영된 반지름으로 변환
export const convertMetersToProjectedRadius = ({ lat, lng }, radius) => {
  const centerLatLng = [lng, lat];
  const edgeLatLng = turf.destination(centerLatLng, radius, 90, { units: 'meters' }).geometry.coordinates;

  const center = fromLonLat(centerLatLng);
  const edge = fromLonLat(edgeLatLng);

  return Math.abs(edge[0] - center[0]);
};

export const createFenceFeatures = (fences) => {
  if (!fences) return [];

  return fences.map((fence) => {
    if (fence.type === 'Circle') {
      const center = fromLonLat([fence.data.center.lng, fence.data.center.lat]);
      const circle = new Circle(center, convertMetersToProjectedRadius(fence.data.center, fence.data.radius));
      return new Feature(circle);
    } else {
      const coordinates = fence.data.boundary.map(({ lat, lng }) => fromLonLat([lng, lat]));
      const closedCoords = [...coordinates, coordinates[0]];
      const polygon = new Polygon([closedCoords]);
      return new Feature(polygon);
    }
  });
};

export const convertFencesToGeoJSON = (fences) => {
  const features = fences.map((fence) => {
    if (fence.type === 'Circle') {
      const center = CoordUtils.arrayFromObject(fence.data.center);
      const turfCircle = turf.circle(center, fence.data.radius, { units: 'meters' });
      const coordinates = turfCircle.geometry.coordinates[0].map((coord) => fromLonLat(coord));
      return new Feature(new Polygon([coordinates]));
    } else {
      const coordinates = fence.data.boundary.map(({ lat, lng }) => fromLonLat([lng, lat]));
      const closedCoords = [...coordinates, coordinates[0]];
      return new Feature(new Polygon([closedCoords]));
    }
  });

  return new GeoJSON().writeFeatures(features, {
    featureProjection: 'EPSG:3857',
    dataProjection: 'EPSG:4326',
  });
};
